import arrow from "../../../res/svg/arrow.svg";
import "./advsblock.css";

function Advsblock(props){
    const heading = props.heading
    const desc = props.desc

    return(
        <div className="adv">
            <div className="advheading">
                <img src = {arrow} alt = "arrow" style = {{marginRight: "1rem", width: "2.5rem", height: "auto"}}></img>
                <h5>{heading}</h5>
            </div>

            <h6 style = {{marginLeft: "3.5rem"}}>{desc}</h6>
        </div>
    )
}

export default Advsblock;